export default "__VITE_ASSET__8a19d0b1__$_?react__"